import React from 'react';

import { ExternalFulfillmentCarrierLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

export const ExternalFulfillmentCarrier = () => {
  const { carrierName } = useFulfillmentDisplayContext();

  return <ReadonlyField label={ExternalFulfillmentCarrierLabel}>{carrierName}</ReadonlyField>;
};
